export class OutgoingTransaction {
  special_instructions: string;
  wait_for_attachments: boolean = false;
  describe: string;
  needs_check: boolean = false;
  check_payee_id: number | null;
  check_payee_name: string | null;
  check_amount: number;
  priority: boolean = false;
  proof_date: string;
  type_served: string;
  copies: number = 1;
  include_file_copy: boolean = true;
  include_proof: boolean = false;
}
